const WEBSITE_INPUT_KEYS = [
  'title',
  'language',
  'url',
  'additionalLanguages',
  'additionalUrls',
  'trackVisitors',
  'trackPageViews',
  'linkTracking',
  'useCookies',
  'cookiePrefix',
  'customCSS',
  'scriptKey',
  'excludedUrls',
  'categoryIds',
  'matomoSettings',
  'matomoVisitDimensions',
  'matomoActionDimensions',
  'ownerId',
  'formAnalytics',
  'mediaAnalytics',
  'crashAnalytics',
  'checkInterval',
  'checkReportEmail',
  'ga4PropertyId',
];

const MATOMO_SETTINGS_INPUT_KEYS = [
  'excludedIPs',
  'excludedParameters',
  'excludedUserAgents',
  'keepUrlFragment',
  'siteSearch',
  'siteSearchDefaultParameters',
  'siteSearchKeywordParameters',
  'siteSearchCategoryParameters',
  'ecommerce',
  'disableVisitorLog',
  'disableVisitorProfile',
  'currency',
  'timezone',
];

function pick(obj, keys) {
  if (!obj) return obj;
  return Object.fromEntries(keys.filter(key => obj[key] !== undefined).map(key => [key, obj[key]]));
}

function getUpdateWebsiteVariables(website, values = {}) {
  const input = pick(values, WEBSITE_INPUT_KEYS) || {};
  if (input.matomoSettings) {
    input.matomoSettings = pick(input.matomoSettings, MATOMO_SETTINGS_INPUT_KEYS);
  }
  return {
    id: website?.id || values.id,
    input,
  };
}

module.exports = { getUpdateWebsiteVariables };
